export const SEARCH_ERROR = 'Unable to load search results';
export const MISSING_REQUIRED_PARAMS_ERROR = 'To search, please select values for "Current Student at:" and "Term & Year."'
export const HOME_CAMPUS_SELECT_EMPTY_ERROR = 'Please select a home campus'
export const TERM_YEAR_SELECT_EMPTY_ERROR = 'Please select a term & year'
export const INTERNAL_ERROR = 'Internal error. Please try again at a later time.'